<div class="loggedInAsContainer">
  <div *ngIf="currentUser.isAuthenticated">
    <div class="loggedInAsTitle">
      <mat-icon class="secondary-icon" color="accent">info</mat-icon>
      <div class="loggedInAsCaption">Logged in as: </div>
    </div>
    <div class="lineContainer">
      <span class="userName">{{currentUser.firstName}} {{currentUser.lastName}}</span>
    </div>
    <div class="lineContainer">
      <span class="email">{{currentUser.email}}</span>
    </div>

    <div class="access-container">
      <span class="access-heading">Access Summary</span>
      <table *ngIf="accessSummary">
        <tr>
          <td>
            <span *ngIf="accessSummary.capex.type" class="type-heading">CAPEX:&nbsp;</span>
          </td>
          <td>
            <span class="type">{{accessSummary.capex.display}} </span>
          </td>
        </tr>
        <tr>
          <td>
            <span *ngIf="accessSummary.opex.type" class="type-heading">OPEX:&nbsp;</span>
          </td>
          <td>
            <span class="type">{{accessSummary.opex.display}} </span>
          </td>
        </tr>
      </table>
    </div>

  </div>
  <div *ngIf="!currentUser.isAuthenticated">
    <div class="loggedInAsCaption">Not Logged In</div>
  </div>
</div>